var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveCandidatesDashboardIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 13.6001V12.2001C10.8 11.4575 10.505 10.7453 9.9799 10.2202C9.4548 9.69515 8.74261 9.40015 8 9.40015H3.8C3.05739 9.40015 2.3452 9.69515 1.8201 10.2202C1.295 10.7453 1 11.4575 1 12.2001V13.6001",
    stroke: "#80A8FF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89998 6.6C7.44637 6.6 8.69998 5.3464 8.69998 3.8C8.69998 2.2536 7.44637 1 5.89998 1C4.35358 1 3.09998 2.2536 3.09998 3.8C3.09998 5.3464 4.35358 6.6 5.89998 6.6Z",
    stroke: "#80A8FF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.6001V12.2001C14.9996 11.5797 14.7931 10.977 14.413 10.4867C14.0329 9.99636 13.5007 9.64616 12.9 9.49106M10.8 1.09106C11.4023 1.24528 11.9362 1.59556 12.3174 2.08668C12.6986 2.57781 12.9055 3.18185 12.9055 3.80356C12.9055 4.42528 12.6986 5.02932 12.3174 5.52045C11.9362 6.01157 11.4023 6.36185 10.8 6.51606",
    stroke: "#80A8FF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCandidatesDashboardIconDark);
export default __webpack_public_path__ + "static/media/active-candidates-dashboard-icon-dark.6fe152fdaee466be11572aef54047f28.svg";
export { ForwardRef as ReactComponent };